import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top of the page when the pathname changes
    // This is useful for single-page applications where the content changes
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant" // Optional: adds a smooth scroll effect
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;